var header = document.querySelector('#app > header');
var mobile_nav = header.querySelector('.banner');
var simple_banner = document.querySelector('#simple-banner');

if(header && mobile_nav && simple_banner){
    banner_height = simple_banner.getBoundingClientRect().height;
    mobile_nav.style.top = banner_height + "px";
    header.style.marginTop = banner_height + "px";

    window.onscroll = function() {
        if(window.scrollY > 10){
            simple_banner.style.display = "none";
        } else {
            simple_banner.style.display = "block";
        }
    };
}